import { TolerancePercentage } from "../models/tolerancePercentage";
import BaseService from "./_base.service";

const endpoint = "tolerance";

const TolerancePercentageService = {
  ...BaseService<TolerancePercentage>({ endpoint }),
};

export default TolerancePercentageService;
